import { gsap } from "gsap";

export default class ProductTableHandler {
    constructor() {
        this.tables = [];
        this.initialRows = 5;
    }

    init() {
        gsap.utils.toArray('[data-product-table]').forEach((e) => {
            const table = e.querySelector('tbody');
            const toggleButton = e.querySelector('button');

            if (!table || !toggleButton) {
                return;
            }

            const allRows = gsap.utils.toArray('tr', table);
            const hiddenRows = allRows.slice(this.initialRows);

            if (hiddenRows.length === 0) {
                return;
            }

            // Store table data
            this.tables.push({
                element: e,
                table,
                button: toggleButton,
                rows: hiddenRows,
                isExpanded: false
            });

            this.attachEventListener(toggleButton, hiddenRows);
        });

        this.initProductFilter();
    }

    attachEventListener(button, rows) {
        let isExpanded = false;

        button.addEventListener('click', () => {
            if (isExpanded) {
                rows.forEach(row => {
                    row.classList.add('hidden');
                });
                button.textContent = 'Show more';
                isExpanded = false;
            } else {
                rows.forEach(row => {
                    row.classList.remove('hidden');
                });
                button.textContent = 'Show less';
                isExpanded = true;
            }
        });
    }

    initProductFilter() {
        const select = document.querySelector('[data-taxonomy-select="therapeutic_area"]');
        if (!select) return;

        select.addEventListener('change', (e) => {
            this.filterByTherapeuticArea(e.target.value);
        });
    }

    filterByTherapeuticArea(slug) {
        const categorySections = document.querySelectorAll('[data-category-section]');

        categorySections.forEach(section => {
            const rows = section.querySelectorAll('tbody tr');
            let visibleCount = 0;

            rows.forEach(row => {
                const areas = row.getAttribute('data-therapeutic-areas') || '';
                const match = !slug || areas.split(',').includes(slug);

                if (match) {
                    row.classList.remove('hidden');
                    visibleCount++;
                } else {
                    row.classList.add('hidden');
                }
            });

            // Hide category section entirely if no rows match
            section.classList.toggle('hidden', visibleCount === 0);

            // Hide "show more" button when filtered — all matches are visible
            const toggleButton = section.querySelector('[data-product-table] button');
            if (toggleButton) {
                toggleButton.classList.toggle('hidden', !!slug);
            }
        });
    }
}
